import { createContext, useContext, type ReactNode } from 'react';
import type { AccountInfo } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

/**
 * email-hub AuthProvider — mirrors Fireball.Ui/src/context/use-auth.tsx's shape
 * (MSAL account context surfaced via useMsal), minus Fireball's user/nav API:
 * email-hub has a fixed four-screen nav and no `/api/auth` backend, so there is
 * no per-user route gating to resolve. The redirect-login gate runs at init in
 * `main.tsx` (task [3.1]), so by the time this provider mounts an account
 * always exists; it exposes the active account for consumers that need it.
 */
const AuthContext = createContext<{ account: AccountInfo | null }>({
	account: null,
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
	const { accounts } = useMsal();
	const account = accounts[0] ?? null;

	return (
		<AuthContext.Provider value={{ account }}>{children}</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
